import { render, staticRenderFns } from "./3_solution.vue?vue&type=template&id=55f01a06&scoped=true&"
import script from "./3_solution.vue?vue&type=script&lang=js&"
export * from "./3_solution.vue?vue&type=script&lang=js&"
import style0 from "./3_solution.vue?vue&type=style&index=0&id=55f01a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f01a06",
  null
  
)

export default component.exports